<template>
  <div>
    <Nav :authenticated="authFlag" />
    <header class="hero">
      <div class="container-fluid d-none">
        <div class="row">
          <div
            style="padding: 0;"
            :class="!auth.authenticated ? 'col-md-8' : 'col-md-12'"
            class="hero__map"
          >
            <Map
              :coordinates="coordinates"
              :styles="mapStyles"
              :infoWindows="infoWindows"
              :markers="null"
              :height="!auth.authenticated ? '514px' : '360px'"
              type="roadmap"
            />
          </div>
          <div class="col-md-4 hero__login" v-if="!auth.authenticated">
            <div class="container text-white">
              <div class="mb-5">
                <h2 class="title">Create an account</h2>
                <small
                  class="text-light d-block"
                >Create an Infodemics account to begin.</small>
              </div>

              <div class="buttons-group mb-3">
                <button @click="auth.auth0login()" class="btn btn-dark btn-social btn-facebook">
                  <ion-icon name="logo-facebook"></ion-icon>Sign Up with Facebook
                </button>
                <button @click="auth.auth0login()" class="btn btn-dark btn-social btn-google">
                  <ion-icon name="logo-google"></ion-icon>Sign Up with Google
                </button>
                <button
                  type="button"
                  class="btn btn-social btn-light"
                  data-toggle="modal"
                  data-target="#signupModal"
                >
                  <ion-icon name="ios-call"></ion-icon>Sign Up with Phone
                </button>
              </div>

              <p class="d-block text-light mb-2">
                Already have an account?
                <a
                  href="#loginModal"
                  data-toggle="modal"
                  data-target="#loginModal"
                  class="text-white"
                >
                  <b>Login</b>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row hero__content">
          <div class="col-12 col-md-6">
            <h1 class="mt-0 mb-2">Risk Communication Platform For Africa<sup>†</sup></h1>
            <p>Infodemics uses existing social hierarchies in a community to efficiently and effectively communicate health risk.</p>
            <p><small><sup>†</sup>Africa first. You can use Infodemics for your location too!</small></p>
            <a href="/blog" class="btn btn-primary btn-lg d-inline">Read our Blog</a>
          </div>
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <section class="highlights bg-light py-0">
      <div class="container-fluid">
        <div class="row no-gutter">
          <div class="col-12 col-md-5 highlights__image">
            <div></div>
          </div>
          <div class="col-12 col-md-7 highlights__items">
            <div class="row">
              <div class="col-12 mb-5">
                <h3>What is Infodemics?</h3>
              </div>

              <div class="col-12 col-md-6">
                <img src="./icons/communication.svg" height="50" alt="Location" />
                <h6 class="text-uppercase mt-4">Risk communication has new shifts</h6>
                <p
                >Experts and authorities are less trusted. The public’s source of health advice is now online and social. And media works differently now with the rise of opinion versus well sourced news.</p>
                <p
                >A two-way multi-directional communication which engages an affected population to help them take informed decisions to protect themselves and loved ones is needed.</p>
              </div>

              <div class="col-12 col-md-6">
                <img src="./icons/location.svg" height="50" alt="Location" />
                <h6 class="text-uppercase mt-4">Risk communication done better</h6>
                <p
                >Infodemics is a one stop risk communication platform which brings parties together in circles, communicating with leaders: traditional, social and religious using modern channels of SMS, email, IVR and similar.</p>
                <p
                >Infodemics uses technology to raise awareness, build up knowledge on hazards and risks and inform behavious during events while improving relationships, building trust and involving actors in decision making.</p>
              </div>

            </div>
          </div>
        </div>
        <div class="row no-gutter">
          <div class="col-12 col-md-7 highlights__items">
            <div class="row">
              <div class="col-12 mb-5">
                <h3>Infodemics features</h3>
              </div>

              <div class="col-12 col-md-6">
                <img src="./icons/circles.svg" height="50" alt="Location" />
                <h6 class="text-uppercase mt-4">Work With Circles</h6>
                <p>Various teams work in concert to stem outbreaks. Use our circles to manage government health agencies, community groups and more.</p>
              </div>

              <div class="col-12 col-md-6">
                <img src="./icons/communication.svg" height="50" alt="Location" />
                <h6 class="text-uppercase mt-4">Communicate Risk</h6>
                <p
                >Use our inbuilt mediums to communicate health risks. SMS, Interactive Voice Response (IVR), USSD shortcodes, eMail and similar channels are easy to use.</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-5 highlights__ft">
            <div></div>
          </div>
        </div>
        <div class="row no-gutter">
          <div class="col-12 col-md-5 highlights__part">
            <div></div>
          </div>
          <div class="col-12 col-md-7 highlights__items">
            <div class="row">
              <div class="col-12 mb-5">
                <h3>Infodemics Partners</h3>
              </div>

              <div class="col-12 col-md-6">
                <img src="./icons/partner.svg" height="50" alt="Location" />
                <h6 class="text-uppercase mt-4">Planning and Intervention</h6>
                <p>Infodemics can be used to manage volunteers, coordinate with communities, provide accurate feedback and have an all in one communication solution.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <LoginModal :auth="auth" />
    <SignupModal :auth="auth" />
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Nav from "@/components/Landing/Nav/Nav.vue";
import LoginModal from "@/components/Auth/LoginModal/LoginModal.vue";
import SignupModal from "@/components/Auth/SignupModal/SignupModal.vue";
import Footer from "@/components/Landing/Footer/Footer.vue";

export default {
	name: "apps",
	props: ["auth", "authenticated"],
	data() {
    return {
      authFlag: this.$props.authenticated
    };
  },
	components: {
    Nav,
    Footer,
    LoginModal,
    SignupModal
	}
}
</script>
<style scoped lang="scss" src="./Landing.scss"></style>